export default {
  notAccessPage:'You do not have access to this page :(',
  goToCabinet:"Return to the cabinet",
  own: "Own",
  invited:"Invited",
  enterConfirmationCode: 'Enter the confirmation code',
  verificationCodeHasBeenSentYourNumber: 'A verification code has been sent to your phone number',
  shareLink:"Using a phone number or link you can invite a friend or colleague",
  linkTeam:"The invitation link has been created.",
  sendSmsAgain: 'Send sms again',
  copyTaskLink: 'Copy the task link',
  copyLink:"Copy link",
  sentSuccess:"Sent successfully",
  successJoin:"You have successfully joined the team",
  phoneError:"Phone number must be 9 digits",
  wantAddTeam:"wants to add you to the team",
  join:"Join",
  send:"Send",
  support: 'Support',
  REDColor: 'RED',
  YELLOWColor: 'YELLOW',
  GREENColor: 'GREEN',
  BLUEColor: 'BLUE',
  modules: 'Modules',
  loading: 'Loading...',
  systemErrorTitle: 'System failure',
  systemErrorDescription: 'Try again later',
  noteName: 'Note name',
  createNote: 'Create note',
  editNote: 'Edit note',
  changePlan: 'Change plan',
  hitLimitDesc: 'To continue please change your plan',
  hitLimitTitle: "You've hit your limit",
  allTasks: 'All tasks',
  newTask: 'New Task',
  startFromScratch: "Let's start from scratch",
  teamNotFound: 'Team not found',
  teamNotFoundDesc: "You don't have a team to create a project",
  projectNotFound: 'Project not found',
  projectNotFoundDesc: "You don't have a project to create a task",
  singlyProject: 'Single project',
  newProject: 'New Project',
  selected: 'Selected',
  view: 'View',
  videoInstruction:"Video instruction",
  resetPassword: 'Reset the password',
  selectAll: 'Select all',
  creatTeamDescription: 'Create your dream team',
  createTeam: 'Create a team',
  managerNotFound: 'Manager not found!',
  managerNotFoundDescription:
    'To perform this action, you need to select a manager from the list of users.',
  refreshBtn: 'Refresh',
  attachManagerbtn: 'Attach Manager',
  gantt: 'Gantt',
  haveScreenShot: 'Have a screenshot',
  activity: 'Activity',
  activityInPlatform: 'Activity in platform',
  actionCount: 'Action count',
  taskCount: 'Task count',
  wastedTime: 'Daily wasted time for task',
  noActivity: 'No activity',
  enter: 'Enter',
  leave: 'Leave',
  noScreenshot: 'No',
  yesScreenShot: 'Yes',
  onlyWithScreenshots: 'Only with screenshots',
  dashboard: {
    language: 'Language',
    languageChange: 'Change language'
  },
  notification: {
    error: 'Error',
    warning: 'Warning',
    success: 'Success'
  },
  menu: {
    home: 'Home',
    task: 'Task | Tasks',
    project: 'Project | Projects',
    user: 'User | Users',
    role: 'Role | Roles',
    organization: 'Organization | Organizations',
    company: 'Company | Companies',
    office: 'Office | Offices',
    department: 'Department | Departments',
    permission: 'Permission | Permissions',
    team: 'Team | Teams',
    report: 'Report | Reports',
    projectOverview: 'Project Overview',
    projectReport: 'Projects Report',
    timeSeries: 'Time Sheet',
    timeFrame: 'Employment Overview',
    projectDetailsTask: 'Detailed Project Report',
    userActivity: 'User activity',
    projectDetailsManager: 'Project Manager Report',
    projectDetailsEmployee: 'Project Executives Report',
    dailyReport: 'Daily report',
    usersTasksReport: "User's tasks report",
    reportEtmAgent: 'KPI-Agent report',
    spaces: 'Spaces',
    staff: 'Staffs'
  },
  repoerts: {
    kanban: 'Kanban',
    boardName: 'Project Name',
    numberBoards: 'Number of projects',
    sumTasks: 'Number of tasks',
    noTask: 'No task',
    tasksName: 'Tasks Name'
  },
  actionItem: {
    CREATE_PROJECT: 'created this project',
    DELETE_PROJECT: 'deleted this project',
    CHANGE_PROJECT: 'renamed this project from "{oldProName}" to "{newProName}"',
    INVITE_MEMBER: 'added "{inviteUser}" to this project',
    REMOVE_MEMBER: 'deleted "{removeUser}" from this project',
    ADD_PROJECT_COLUMN: 'added column "{addProColumn}" to this project',
    UPDATE_PROJECT_COLUMN: 'renamed column from "{updateNameColumn}" to "{newNameColumn}"',
    DELETED_PROJECT_COLUMN: 'deleted column "{text}"',
    CREATE_TASK: 'created task "{task}" in column "{column}"',
    UPDATE_TASK: 'updated task "{oldTask}" to "{newTask}"',
    DELETE_TASK: 'deleted task "{text}"',
    MOVE_TASK: 'moved task "{task}" from column "{oldColumn}" to column "{newColumn}"',
    COPY_TASK: 'copied task "{oldTask}" to column "{column}" as "{newTask}"',
    JOIN_TASK_MEMBER: 'added "{joinMember}" into task "{joinTask}"',
    REMOVE_TASK_MEMBER: 'deleted "{removeUser}" from task "{joinTask}"',
    CREATE_CHECKLIST_GROUP: 'added checklist group "{createGroup}" to task "{taskName}"',
    DELETE_CHECKLIST_GROUP: 'deleted checklist group "{deleteGroup}" from task "{taskName}"',
    CREATE_CHECKLIST_ITEM: 'added checklist element "{checkListName}" to task "{taskName}"',
    DELETE_CHECKLIST_ITEM: 'deleted checklist element "{checkListText}" from task "{taskName}"',
    COMPLETE_CHECKLIST_ITEM: 'checked checklist element "{checkListText}" in task "{taskName}"',
    ADD_COMMENT: 'added comment "{addComment}" to task "{addName}"',
    ADD_CHECKLIST: 'added checklist element "{checkListName}" to task "{taskName}"',
    CHANGE_COMMENT:
      'changed comment from "{changeCommentOld}" to "{changeCommentNew}" in task "{taskName}"',
    DELETE_COMMENT: 'deleted comment "{deleteComment}" from task "{taskName}"',
    ADD_ATTACHMENT: 'attached file "{addAttachment}" to task "{taskName}"',
    DELETE_ATTACHMENT: 'deleted file "{deleteAttachment}" from task "{taskName}"',
    ADD_DUE_DATE: 'set due date "{addDate}" for task "{taskName}"',
    UPDATE_TASK_DESCRIPTION:
      'changed description from "{changeDescriptionOld}" to "{changeDescriptionNew}" in task "{taskName}"'
  },
  boardColumn: {
    addTask: 'Add task',
    commentedCard: 'Commented card'
  },
  profileMenuModal: {
    editProfile: 'Edit profile',
    uploadPhoto: 'Upload photo'
  },
  weather: {
    Smoke: 'Smoke',
    Mist: 'Mist',
    Rain: 'Rain',
    Sun: 'Sun',
    Clear: 'Clear',
    Clouds: 'Clouds',
    Thunderstorm: 'Thunderstorm',
    Snow: 'Snow',
    Drizzle: 'Drizzle'
  },
  Clear: 'Clear',
  myNote: 'My Notes',
  myList: 'MY LIST',
  EVENT: 'Event',
  CONFERENCE: 'Conference',
  ALERT: 'Alert',
  BIRTHDAY: 'Birthday',
  createTask: 'Create task',
  taskTitle: 'Enter task name',
  nameIsRequired: '«Task name» is required',
  thereIsNoData: 'No data',
  projectIsRequired: 'Selection project is required',
  status: 'Status',
  statusIsRequired: 'Selection column is required',
  filter: 'Filter',
  search: 'Search',
  nameProject: 'Project name',
  taskName: 'Task name',
  deadline: 'Deadline',
  cancel: 'Cancel',
  add: 'Add',
  fullName: 'Full name',
  userName: 'Username',
  userNameProfile: 'User name',
  birthday: 'Date of birth',
  edit: 'Edit',
  delete: 'Delete',
  addUser: 'Add user',
  uploadPhoto: 'Upload photo',
  password: 'Password',
  name: 'Name',
  firstName: 'First name',
  lastName: 'Last name',
  middleName: 'Middle name',
  language: 'Language',
  email: 'E-mail',
  save: 'Save',
  userEditing: 'Editing user',
  editPhoto: 'Edit photo',
  addRole: 'Add role',
  nameRequiredField: 'Name is required',
  codeName: 'Code name',
  codenameRequiredField: 'Code name is required',
  id: 'ID',
  accessQuantity: 'Permission qt.',
  permissions: 'Permissions',
  editRole: 'Edit role',
  availablePermissions: 'Аvailable Permissions',
  resolution: 'Resolution',
  editPermissions: 'Edit Permissions',
  normal: 'Normal',
  shownWith: 'Shown with',
  by: 'By',
  of: 'Of',
  emailAddress: 'E-mail Address',
  subject: 'Subject',
  message: 'Message',
  profile: 'Profile',
  rememberMyPreference: 'Remember my preference',
  submit: 'Submit',
  downloadExcel: 'Download in Excel',
  day: 'day',
  week: 'Week',
  month: 'Month',
  year: 'Year',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  sun: 'Sun',
  total: 'Total',
  january: 'January',
  february: 'February',
  mart: 'Mart',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  choose: 'Choose',
  executor: 'Executor',
  priority: 'Priority',
  deadlineLast: 'Last deadline',
  timeSpent: 'Time spent',
  menuW: 'Menu',
  taskSearch: 'Task search',
  taskStatus: 'Task status',
  priorityHigh: 'High',
  priorityNormal: 'Normal',
  priorityLow: 'Low',
  changeBackground: 'Change background',
  projectSettings: 'Project settings',
  actionsAndComments: 'Comments & Actions',
  actions: 'Actions',
  enterSearchTerm: 'Enter a search term: word, label, member name, or due date.',
  column: 'Column',
  problem: 'Problem',
  solution: 'Solution',
  information: 'Information',
  attachment: 'Attachment',
  changeAttachment: 'Change the attachment',
  linkName: 'Link Name',
  hideSelected: 'Hide selected',
  showTagged: 'Show tagged',
  tagSomeone: 'Tag someone',
  taskParticipants: 'Task members',
  description: 'Description',
  tags: 'Tags',
  members: 'Members',
  deadlineS: 'Deadline',
  notSet: 'Not set',
  kvartalOne: 'quarter - 1',
  kvartalTwo: 'quarter - 2',
  kvartalThree: 'quarter - 3',
  kvartalFour: 'quarter - 4',
  addTags: 'Add tags',
  kvartal: 'Quarter',
  copyCard: 'Copy card',
  copyTask: 'Copy link',
  copy: 'Copy',
  copyTo: 'Copy to',
  moveCard: 'Move card',
  position: 'Position',
  move: 'Move',
  difficultyLevel: 'Difficulty level',
  taskCompletionDate: 'Task completion date',
  date: 'Date',
  time: 'Time',
  hour: 'Hour',
  minute: 'Minute',
  chooseDateTime: 'Choose date and time together',
  remove: 'Remove',
  checkList: 'Check list',
  addTaskList: 'Add check list',
  start: 'Start',
  stop: 'Stop',
  phoneNumber: 'Phone number',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  fieldRequired: 'Field required',
  minimumRequired: 'Minimum 6 characters required',
  passwordRepeatNew: 'Repeat new password',
  fieldNewPassword: 'The field does not match the New Password field',
  logout: 'Logout',
  boardMembers: 'Board members',
  invite: 'Invite',
  inviteBoard: 'Invite to the board',
  searchEmployeeName: 'Search for employee name',
  workerFound: 'Employee not found',
  addList: 'Add list',
  addNewColumn: 'Add new column',
  createProject: 'Create project',
  all: 'All',
  manager: 'Manager',
  managers: 'Managers',
  percent: 'Percent',
  group: 'Group',
  typeProject: 'Project view',
  editProject: 'Edit project',
  create: 'Create',
  teamName: 'Team name',
  departments: 'Departments',
  BranchMaintenanceTerminals: 'Branch for repair and maintenance of terminals, ATMs',
  nameEmployee: 'User full name',
  more: 'More',
  chief: 'Chief',
  areYouSure: 'Are you sure?',
  cannotUndoAction: 'You cannot undo this action!',
  deleteTask: 'Delete this task',
  deleteComment: 'Delete this comment',
  saveAsPdf: 'Save as PDF',
  close: 'Close',
  permission: {
    HOMES: 'Home',
    AUTH_TRY_CREATE: 'Auth try create',
    AUTH_TRY_READ: 'Auth try read',
    BACKGROUND_CREATE: 'Background create',
    BACKGROUND_DELETE: 'Background delete',
    BACKGROUND_READ: 'Background read',
    BACKGROUND_UPDATE: 'Background update',
    CERTIFICATE_UPDATE: 'Certificate update',
    CHECKLIST_GROUP_CREATE: 'Checklist group create',
    CHECKLIST_GROUP_DELETE: 'Checklist group delete',
    CHECKLIST_GROUP_READ: 'Checklist group read',
    CHECKLIST_GROUP_UPDATE: 'Checklist group update',
    COIN_CREATE_AND_UPDATE: 'Coin create and update',
    COIN_READ: 'Coin read',
    EMPLOYEE_ALL_WITH_PHOTO: 'Employee all with photo',
    EMPLOYEE_CREATE: 'Employee create',
    EMPLOYEE_DELETE: 'Employee delete',
    EMPLOYEE_READ: 'Employee read',
    EMPLOYEE_UPDATE: 'Employee update',
    ERROR_MESSAGE_CREATE: 'Error message create',
    ERROR_MESSAGE_DELETE: 'Error message delete',
    ERROR_MESSAGE_READ: 'Error message read',
    ERROR_MESSAGE_UPDATE: 'Error message update',
    FILE_STORAGE_CREATE: 'File storage create',
    FILE_STORAGE_READ: 'File storage read',
    GROUP_CREATE: 'Group create',
    GROUP_DELETE: 'Group delete',
    GROUP_READ: 'Group read',
    GROUP_UPDATE: 'Group update',
    LANGUAGE_READ: 'Language read',
    PERMISSION_CREATE: 'Permission create',
    PERMISSION_DELETE: 'Permission delete',
    PERMISSION_READ: 'Permission read',
    PERMISSION_UPDATE: 'Permission update',
    PROJECT_CHANGE_PHOTO: 'Project change photo',
    PROJECT_COLUMN_CREATE: 'Project column create',
    PROJECT_COLUMN_DELETE: 'Project column delete',
    PROJECT_COLUMN_READ: 'Project column read',
    PROJECT_COLUMN_READ_DETAILS: 'Project column read details',
    PROJECT_COLUMN_UPDATE: 'Project column update',
    PROJECT_CREATE: 'Project create',
    PROJECT_DELETE: 'Project delete',
    PROJECT_MEMBER_CREATE: 'Project member create',
    PROJECT_MEMBER_READ: 'Project member read',
    PROJECT_MEMBER_READ_EMPLOYEE: 'Project member read employee',
    PROJECT_READ: 'Project read',
    PROJECT_READ_DETAILS: 'Project read details',
    PROJECT_TAG_CREATE: 'Project tag create',
    PROJECT_TAG_DELETE: 'Project tag delete',
    PROJECT_TAG_READ: 'Project tag read',
    PROJECT_TAG_UPDATE: 'Project tag update',
    PROJECT_UPDATE: 'Project update',
    ROLE_ATTACH_PERMISSION: 'Role attach permission',
    ROLE_CREATE: 'Role create',
    ROLE_DELETE: 'Role delete',
    ROLE_READ: 'Role read',
    ROLE_UPDATE: 'Role udate',
    SUB_TYPE_CREATE: 'Sub type create',
    TASK_ACTION_READ: 'Task action read',
    TASK_ATTACHMENT_BIND: 'Task attachment bind',
    TASK_ATTACHMENT_READ: 'Task attachment read',
    TASK_CHECK_CREATE: 'Task check create',
    TASK_CHECK_DELETE: 'Task check delete',
    TASK_CHECK_READ: 'Task check read',
    TASK_CHECK_UPDATE: 'Task check update',
    TASK_COMMENT_CREATE: 'Task comment create',
    TASK_COMMENT_DELETE: 'Task comment delete',
    TASK_COMMENT_READ: 'Task comment read',
    TASK_COMMENT_UPDATE: 'Task comment update',
    TASK_CREATE: 'Task create',
    TASK_CREATE_TIME: 'Task create time',
    TASK_DELETE: 'Task delete',
    TASK_MEMBER_CREATE: 'Task member create',
    TASK_MEMBER_DELETE: 'Task member delete',
    TASK_MEMBER_READ: 'Task member read',
    TASK_MOVE: 'Task move',
    TASK_READ: 'Task reade',
    TASK_READ_DETAILS: 'Task read details',
    TASK_TAG_CREATE: 'Task tag create',
    TASK_TAG_DELETE: 'Task tag delete',
    TASK_TAG_READ: 'Task tag read',
    TASK_TAG_UPDATE: 'Task tag update',
    TASK_UPDATE: 'Task update',
    TYPE_CREATE: 'Type create',
    TYPE_DELETE: 'Type delete',
    TYPE_READ: 'Type read',
    TYPE_UPDATE: 'Type update',
    USER_ATTACH_ROLE: 'User attach role',
    USER_CREATE: 'User create',
    USER_DELETE: 'User delete',
    USER_READ: 'User read',
    USER_UPDATE: 'User update',
    REPORT_KANBAN_PROJECT_MANAGER_AND_MEMBER: 'Report kanban project manager and member',
    REPORT_TRELLO_PROJECT_MANAGER_AND_MEMBER: 'Report trello project manager and member',
    REPORT_CHART_KANBAN_PROJECT: 'Report chart kanban project',
    REPORT_CHART_TRELLO_PROJECT: 'Report chart trello project',
    REPORT_KANBAN_TRELLO_PROJECT_WITH_USER: 'Report kanban trello project with users',
    REPORT_TIME_LEFT: 'Report time left',
    REPORT_MANAGERS_MEMBERS_UPLOAD: 'Report managers members upload',
    REPORT_PERSONAL_UPLOAD: 'Report personal upload',
    REPORT_TIME_LEFT_UPLOAD: 'Report time left upload',
    TASK_COPY: 'Task copy',
    USER_LAST_LOGIN_CREATE: 'User last login create',
    USER_LAST_LOGIN_READ: 'User last login read',
    MANAGER_RENAME_TASK_PROJECT: 'Manager rename task project',
    ORGANIZATION_CREATE: 'Organization Create',
    ORGANIZATION_UPDATE: 'Organization Update',
    ORGANIZATION_DELETE: 'Organization Delete',
    ORGANIZATION_READ: 'Organization Read',
    EMPLOYEE_PASSWORD_CHANGE: 'Password reset',
    EMPLOYEE_PROFILE_UPDATE: 'Profile edit',
    ALARM_READ: 'Alarm read',
    ALARM_UPDATE: 'Alarm update',
    PROJECT_ARCHIVE: 'Archive project',
    REPORT_FOR_PROJECT: "User's tasks report",
    REPORT_ETM_DESKTOP: 'Report KPI-AGENT'
  },
  createLabel: 'Create label',
  newPassword: 'New password',
  comments: 'Comments',
  nameOfEmployees: 'Name of employees',
  notifications: 'Notifications',
  markAllAsRead: 'Mark all as read',
  allRightsReserved: 'All rights reserved',
  noList: 'No list',
  newName: 'New name',
  indicateTheReasonForTheChange: 'Indicate the reason for the change',
  completion: 'Completion',
  color: 'Color',
  share: 'Share',
  shareViaEmail: 'Share via Email',
  shareViaTelegram: 'Share via Telegram',
  writeAComment: 'Write a comment ...',
  workers: 'Workers',
  added: 'Added',
  hoursAgo: ' hour(s) ago',
  minutesAgo: ' minutes ago',
  secondsAgo: ' seconds ago',
  in: 'in',
  to: 'to',
  at: 'at',
  addElement: 'Add element',
  taskDescription: 'Task description',
  addedATask: 'added a task',
  byTerm: 'By term',
  taskPriority: 'Task priority',
  taskDifficultyLevel: 'Task difficulty level',
  notDone: 'Not done',
  completed: 'Completed',
  overdue: 'Overdue',
  expires: 'Expires',
  enough: 'Enough',
  notDelivered: 'Not delivered',
  complicated: 'Complicated',
  easy: 'Easy',
  enoughTime: 'Enough time',
  qrPaymentVending: 'QR Payment Vending',
  toDo: 'To Do',
  electronicTaskManagement: 'Electronic Task Management',
  attachRole: 'Attach Role',
  searchCodeName: 'Search code name',
  statusNameOfBoards: 'Status (name of boards)',
  performers: 'Performers',
  pleaseCheckOneOrMoreUsers: 'Please, check one or more users!',
  pleaseChooseATeamLeader: 'Please, choose a team leader!',
  confirmDelete: "Are you sure you want to open this task?",
  confirmDeleteTeam: 'Deleting a team also deletes projects and tasks associated with the team!',
  confirmDeleteProject: 'Deleting a project also deletes tasks associated with the project!',
  WEEKLY_INTERVAL: 'Week',
  MONTHLY_INTERVAL: 'Month',
  QUARTER_INTERVAL: 'Kvartal',
  YEARLY_INTERVAL: 'Year',
  thisWeek: 'This week',
  lastWeek: 'Last week',
  last7Days: 'Last 7 days',
  instruction: 'Instruction',
  guideVideo: 'Video',
  guidePDF: 'PDF documents',
  guidePPT: 'Presentation',
  noTaskFound: 'No task found!',
  searchInThisProject: 'in project "{message}"',
  paginationText: 'Shown from {shownText} to {fromText} of {toText}',
  wasOnline: 'Was online',
  searchResult: 'search results',
  board: 'Board',
  list: 'List',

  HIGH_LEVEL: 'High',
  NORMAL_LEVEL: 'Normal',
  LOW_LEVEL: 'Low',
  HIGH_PRIORITY: 'High',
  NORMAL_PRIORITY: 'Normal',
  LOW_PRIORITY: 'Low',

  YELLOW: 'Expiring',
  GREEN: 'Sufficient',
  RED: 'Overdue',

  Changed: 'Changed',
  successfullyDeleted: 'Deleted!',
  FileUploadedSuccessfully: 'File uploaded!',
  passwordChanged: 'Your password has been changed!',
  profileEdited: 'Your profile has been edited!',
  SuccessfullyUpdated: 'Updated!',
  EditedBy: 'Edited',
  SuccessfullyAdded: 'Added!',
  SuccessfullyCreated: 'Created!',
  SuccessfullyChanged: 'Changed!',
  SuccessfullySent: 'Sent!',
  SuccessfullyCopied: 'Copied!',
  TheTimerIsRunning: 'The timer is running!',
  TimerStopped: 'Timer stopped',
  Added: 'Added',
  DeadlineSuccessfully: 'The deadline has been set!',
  userUnblocked: 'The user has been unblocked',
  userBlocked: 'The user has been blocked',

  NEW: 'New',
  DOING: 'Doing',
  DONE: 'Done',
  TESTING: 'Testing',
  VERIFY: 'Verified',
  ARCHIVE: 'Archive',
  NOTASKS: 'Did Nothing',
  ALL: 'All',
  ACTIVE: 'Active users',

  TOTALPROJECTS: 'Total number of projects',
  ACTIVEPROJECTS: 'Number of active projects',
  SUCCESSFULPROJECTS: 'Number of successful projects',
  EXPIREDPROJECTS: 'Number of expired projects',
  TOTALTASKS: 'Total number of tasks',
  ACTIVETASKS: 'Number of active tasks',
  SUCCESSFULTASKS: 'Number of successful tasks',
  EXPIREDTASKS: 'Number of expired tasks',

  userTask: 'User Tasks',

  select: 'Select',
  projectType: 'Project type',
  columnName: 'Column name',
  notAvailable: 'Not available',
  deadlineType: 'Deadline type',
  deadlineDate: 'Deadline date',
  hasNoDeadline: 'No deadline',
  inNextDay: 'Next day',
  inNextWeek: 'Next week',
  inNextMonth: 'Next month',
  roleAbsent: 'Role is absent',
  columns: 'Columns',
  organizationName: 'Organization name',
  register: 'Register',
  login: 'Login',
  back: 'Back',
  confirm: 'Confirm',
  confirmationCode: 'Confirmation code',
  confirmationCodeSent: 'Confirmation code is sent to email {email} and phone number {phoneNumber}',
  confirmationCodeSentSmall: 'Confirmation code is sent to {text}',
  passwordRepeat: 'Repeat password',
  forgotPassword: 'Forgot password?',
  resend: 'Resend',
  pasteScreenshot: 'Paste screenshot here',
  crudCreate: 'Create new {text}',
  crudEdit: 'Edit {table} "{name}"',
  crudRead: 'View {table} "{name}"',
  crudPasswordReset: 'Reset password of the user "{name}"',
  teamLeader: 'Team leader',
  photo: 'Photo',
  selectedUsers: 'Selected users',
  table: 'Table | Tables',
  other: 'Other | Others',
  tasksIamAssigned: "Tasks that I'm assigned",
  editInDashboard: 'Edit in dashboard',
  createdDate: 'Created date',
  deadlineStartDate: 'Deadline start',
  deadlineEndDate: 'Deadline end',
  systemAdmin: 'System administrator',
  notSpecified: 'Not specified',
  passwordRecovery: 'Password recovery',
  projectInDashboard: 'Project "{name}" – Dashboard',
  meta: {
    description: {
      login: 'ETM Login - the login page into the system',
      registration: 'ETM Registration - the registration page for new users',
      recovery: 'ETM Recovery - the password recovery page for users'
    },
    keywords: {
      login: 'login, enter, authorization',
      registration: 'registration, account, profile, authorization',
      recovery: 'recovery, password, forgot, authorization'
    }
  },
  projectsSelected: '{count} projects selected',
  usersSelected: '{count} members selected',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  estimateDate: 'Time for accomplishing a task',
  timeGridWeek: 'Time Grid Week',
  dayGridMonth: 'Day Grid Month',
  listWeek: 'List Week',
  dayGridWeek: 'Day Grid Week',
  today: 'Today',
  gantReport: {
    view: 'View',
    viewModules: {
      quarter: 'Quarter',
      year: 'Year',
      day: 'Day',
      week: 'Week',
      month: 'Month'
    }
  },
  dateFrom: 'Date: From',
  To: 'To',
  MyTasks: 'My tasks',
  projectStatus: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    successful: 'Successful',
    unsuccessful: 'Unsuccessful'
  }
};
